import find from 'lodash/find';
import first from 'lodash/first';
import pipe from 'ramda/src/pipe';
import tap from 'ramda/src/tap';
import { registerPaymentHandler } from '../../iosBridge/actions';
import { redirectTo, roleAwareRedirect } from '../../common/helpers/routerActions';
import {
  CANCEL_PAYMENT,
  CLEAR_PAYING_OBJECT,
  CLOSE_CANCEL_PAYMENT_MODAL,
  CLOSE_TIP_SCREEN,
  CREATE_PAYMENT_CARD,
  FETCH_PAYMENT_CARD,
  IOS_BRIDGE_PAYMENT_SUCCESS,
  OPEN_TIP_SCREEN,
  OPEN_URL,
  PAYMENT_FAILED,
  RESET_PAYMENT_CARD,
  SET_PAYING_OBJECT,
  WEBREADER_PAYMENT_SUCCESS,
} from './constants';
import Http from '../../http';
import iosBridge from '../../iosBridge/iosBridgeService';
import config from '../../../config';
import { isIosBridge } from '../../iosBridge/helpers';

export const openTipScreen = payload => ({
  type: OPEN_TIP_SCREEN,
  payload,
});

const openUrl = url => ({
  type: OPEN_URL,
  payload: url,
});

const openPayworksUrl = (merchantInfo, sessionIdentifier) => {
  const href = [
    'payworks://transaction/charge?',
    `sessionIdentifier=${sessionIdentifier}`,
    `&providerMode=${config.providerMode}`,
    '&accessoryFamily=MIURA_MPI',
    `&merchantIdentifier=${merchantInfo.merchantId}`,
    `&merchantSecretKey=${merchantInfo.merchantSecret}`,
  ].join('');
  return openUrl(href);
};

export const paymentFailed = () => ({
  type: PAYMENT_FAILED,
});

export const iosBridgePaymentSuccess = transactionIdentifier => ({
  type: IOS_BRIDGE_PAYMENT_SUCCESS,
  payload: transactionIdentifier,
});

export const webreaderPaymentSuccess = payload => ({
  type: WEBREADER_PAYMENT_SUCCESS,
  payload,
});

const openiOSBridge = (
  // eslint-disable-next-line default-param-last
  merchantInfo = {},
  sessionIdentifier,
  paymentIntentId,
  paymentIntentSecret,
  isStripeReader,
) => (dispatch) => {
  dispatch(registerPaymentHandler());

  let payworksData = { providerMode: config.providerMode };
  if (isStripeReader) {
    payworksData = {
      ...payworksData,
      paymentIntentId,
      paymentIntentSecret,
    };
  } else {
    payworksData = {
      ...payworksData,
      sessionIdentifier,
      merchantId: merchantInfo.merchantId,
      merchantSecret: merchantInfo.merchantSecret,
      readerModel: merchantInfo.readerModel,
    };
    if (merchantInfo.ipAddress) {
      payworksData.ipAddress = merchantInfo.ipAddress;
    }
  }
  iosBridge.callHandler('payworks://open', payworksData);
};

export const openPayworks = ({
  merchantInfo,
  identifier,
  paymentIntentId,
  paymentIntentSecret,
  isStripeReader,
}) => (dispatch) => {
  if (isIosBridge() || isStripeReader) {
    dispatch(openiOSBridge(merchantInfo, identifier, paymentIntentId, paymentIntentSecret, isStripeReader));
    return;
  }
  dispatch(openPayworksUrl(merchantInfo, identifier));
  dispatch(iosBridgePaymentSuccess());
};

export const cancelPayment = () => ({
  type: CANCEL_PAYMENT,
});

export const closeTipScreen = () => ({
  type: CLOSE_TIP_SCREEN,
});

export const resetPaymentCard = () => ({ type: RESET_PAYMENT_CARD });

const fetchPaymentCardAction = card => ({
  type: FETCH_PAYMENT_CARD,
  payload: card,
});

export const fetchPaymentCard = customerId => dispatch => Http
  .get(`/customer/${customerId}/payment-card`)
  .then((response) => {
    const card = find(response, 'isDefault') || first(response);
    dispatch(fetchPaymentCardAction(card));
    return response;
  });

const createPaymentCardAction = card => ({
  type: CREATE_PAYMENT_CARD,
  payload: card,
});

export const createPaymentCard = (customerId, token, { shopId, barberId }) => dispatch => Http
  .post(`/customer/${customerId}/payment-card`, { token, shopId, barberId })
  .then(
    tap(pipe(createPaymentCardAction, dispatch))
  );

export const deletePaymentCard = (customerId, id) => Http.delete(`/customer/${customerId}/payment-card/${id}`);

export const setDefaultCard = (customerId, id) => Http.put(
  `/customer/${customerId}/payment-card/${id}`,
  { isDefault: true },
);

export const closeCancelPaymentModal = () => ({
  type: CLOSE_CANCEL_PAYMENT_MODAL,
});

export const clearPayingObject = () => ({
  type: CLEAR_PAYING_OBJECT,
});

export const setPayingObject = payload => ({
  type: SET_PAYING_OBJECT,
  payload,
});

export const redirectToAppointments = () => roleAwareRedirect('/appointments');

export const redirectToRegister = () => roleAwareRedirect('/register');

export const redirectToTipping = () => redirectTo('/customer/tip');
export const redirectToAppointmentTipping = id => redirectTo(`/customer/tip/${id}`);

const ownerFetchPaymentCard = url => dispatch => Http.get(url).then(
  pipe(fetchPaymentCardAction, dispatch)
);

export const fetchOwnerPaymentCard = (ownerId, ownerType) => ownerFetchPaymentCard(
  `/${ownerType}/${ownerId}/payment-card`
);

const ownerCreateCard = (url, data) => dispatch => Http.post(url, data).then(
  pipe(createPaymentCardAction, dispatch)
);
export const createOwnerPaymentCard = (ownerId, ownerType, paymentToken) => ownerCreateCard(
  `/${ownerType}/${ownerId}/payment-card`,
  { paymentToken },
);

const ownerUpdateCard = (url, data) => dispatch => Http.put(url, data).then(
  pipe(createPaymentCardAction, dispatch)
);
export const updateOwnerPaymentCard = (ownerId, ownerType, paymentToken) => ownerUpdateCard(
  `/${ownerType}/${ownerId}/payment-card`,
  { paymentToken },
);
